import logo from './logo.svg';
import './App.css';
import { Route, Routes, BrowserRouter, HashRouter } from "react-router-dom";
import Homepage from './components/home.component';
import Calculator from './components/calculator.component';
import Listing from './components/listing.component';
import Header from './components/header.component';
import Listings from './components/listings.component';
import About from './components/about.comoponent';
import Footer from './components/footer.component';
import Evaluation from './components/evaluation.component';
import Reports from './components/reports.component';
import Contact from './components/contact.component';
import CommercialListings from './components/commercial.component';
import OfficeListings from './components/officeListings.component';
import Testimonials from './components/testimonials.component';
import SellerGuide from './components/sellerGuide.component';
import BuyerGuide from './components/buyerGuide.component';
import { DefaultSEO } from "./components/seo.component";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <div >
        <DefaultSEO />
        <HashRouter>
          <Header />
          <Routes>
            {/* <Route path="*" element={<Error />} /> */}
            <Route path="/" element={<Homepage />} />
            <Route path="/calculator" element={<Calculator />} />
            <Route path="/listing/:id" element={<Listing />} />
            <Route path="/listings" element={<Listings />} />
            <Route path="/about" element={<About />} />
            <Route path="/evaluation" element={<Evaluation />} />
            <Route path="/real-estate-reports" element={<Reports />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/commercial" element={<CommercialListings />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/selling-tips" element={<SellerGuide />} />
            <Route path="/buying-tips" element={<BuyerGuide />} />
          </Routes>
          <Footer />
        </HashRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
